function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M147.636 98.261s-4.894 7.047-11.26 7.413c-6.366.365-11.793-6.089-11.793-6.089s4.804-6.503 11.17-6.868c6.366-.366 11.883 5.544 11.883 5.544zm-40.997 1.624s-5.928 6.456-12.276 5.863c-6.35-.593-10.715-8.01-10.715-8.01s5.725-5.71 12.074-5.116c6.349.593 10.917 7.263 10.917 7.263z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M87.018 84.25c2.716-3.35 6.747-4.586 9.46-4.365 2.642.216 5.283.431 7.636 4.176.129.206.211.438.247.678a2.83 2.83 0 01-3.028 3.246l-13.205-1.077c-1.312-.107-1.957-1.65-1.11-2.658zm56.358.951c-2.606-3.437-6.594-4.803-9.313-4.67-2.647.128-5.294.257-7.768 3.923a1.77 1.77 0 00-.269.67 2.83 2.83 0 002.92 3.343l13.234-.645c1.314-.064 2.009-1.585 1.196-2.621zM92.079 98.423a5.375 5.375 0 1110.531-2.158 5.375 5.375 0 01-10.531 2.158zm41.208-2.205a5.376 5.376 0 1110.438 2.576 5.376 5.376 0 01-10.438-2.576z",
  fill: "#212121"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M127.139 123.309c1.467-.678 2.941.368 1.97 1.661-2.239 2.984-6.968 5.708-12.44 5.708-5.472 0-10.201-2.724-12.441-5.708-.97-1.293.504-2.339 1.971-1.661 2.534 1.171 6.285 2.468 10.47 2.468 4.185 0 7.936-1.297 10.47-2.468z",
  fill: "#5F3460"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.122 90.9c6.807-.332 11.035 5.216 12.602 7.769l-1.514.929c-1.53-2.494-5.265-7.204-11.002-6.924-5.197.254-8.001 2.69-9.954 4.387-.25.217-.486.422-.711.609l-1.134-1.367c.206-.171.429-.366.671-.577 1.967-1.717 5.203-4.54 11.042-4.826zm41.804.089c-6.791-.576-11.215 4.817-12.871 7.313l1.479.982c1.618-2.437 5.519-7.01 11.242-6.526 5.185.44 7.9 2.975 9.792 4.74.242.226.47.44.688.634l1.182-1.326c-.2-.178-.415-.38-.65-.6-1.904-1.786-5.037-4.724-10.862-5.217z",
  fill: "#212121"
});

function SvgFace2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/media/face-2.4ef82d1c.svg";
export { SvgFace2 as ReactComponent };